import React, { Component } from "react"
import { isMobile } from "react-device-detect"
import Svg from "../_svgs/svg"
import QueryString from "query-string"
import FlightSearchComponent from "./parking-flight-search-component"
import ParkingFlightSignupModal from "./parking-flight-signup-modal"
export default class ParkingFollowFlight extends Component {
  constructor(props) {
    super(props)
    this.state = {
      departingTripOverlayOpen: false,
      homeTripOverlayOpen: false,
      departureFlight: undefined,
      arrivalFlight: undefined,
      showFlightSignupModal: false,
    }
  }

  handleDepartingTripOverlay = (value) => {
    this.setState({ departingTripOverlayOpen: value })
  }

  handleHomeTripOverlay = (value) => {
    this.setState({ homeTripOverlayOpen: value })
  }

  setDataToState = (data) => {
    this.setState(data)
  }

  handleSignup = () => {
    this.setState({ showFlightSignupModal: true })
    let textkeys = { ...this.props.modalTextKeys }
    textkeys.departingTripLabel = this.props.departingTripLabel
    textkeys.homeTripLabel = this.props.homeTripLabel
    // Emitter.emit("*", {
    //   type: emits.REQUEST_FLIGHT_SIGNUP_MODAL,
    //   modalJson: {
    //     textKeys: textkeys,
    //     departureFlight: this.state.departureFlight,
    //     arrivalFlight: this.state.arrivalFlight,
    //     profile: this.props.profile,
    //     trackingEventLabel: "parking receipt",
    //     source: "parking",
    //     language: this.props.locale,
    //     email: this.props.email,
    //     phone: this.props.phone,
    //   },
    // })
  }

  render() {
    const { departingTripOverlayOpen, homeTripOverlayOpen } = this.state

    const arrivalDate = `${this.props.arrivalDate} ${this.props.arrivalTime}`

    const queryParam = QueryString.parse(this.props.location.search)

    let isExtendedBooking = false
    let isAmendment = false
    if (queryParam.source === "extension") {
      isExtendedBooking = true
    }
    if (queryParam.source === "amend") {
      isAmendment = true
    }

    if (isExtendedBooking || isAmendment) return ""

    return (
      <>
        <section className="deck deck--front deck--white deck--extra-padding-bottom">
          <div className="w--wider">
            <div
              className="parking-follow-flight"
              style={(departingTripOverlayOpen || homeTripOverlayOpen) && isMobile ? { position: "relative", zIndex: "9999999" } : null}
            >
              <div className="info-wrapper">
                {this.props.iconUpload ? (
                  <div className="icon">
                    <img src={this.props.iconUpload} />
                  </div>
                ) : (
                  <Svg iconName={this.props.icon} />
                )}
                <div className="info">
                  <div className="heading" dangerouslySetInnerHTML={{ __html: this.props.heading }}></div>
                  <div className="description" dangerouslySetInnerHTML={{ __html: this.props.description }}></div>
                </div>
              </div>
              <div className="flight-wrapper">
                <div className="form">
                  <div className="trip-wrapper" style={{ paddingBottom: "15px" }}>
                    <div className="trip-label">{this.props.departingTripLabel}</div>
                    <div
                      className="flight"
                      style={
                        isMobile && departingTripOverlayOpen
                          ? { position: "relative", zIndex: "9999999" }
                          : isMobile && homeTripOverlayOpen
                            ? { position: "relative", zIndex: "100" }
                            : null
                      }
                    >
                      <FlightSearchComponent
                        {...this.props}
                        datetime={arrivalDate}
                        handleOverlay={this.handleDepartingTripOverlay}
                        setDataToState={this.setDataToState}
                        chosenFlight={this.state.departureFlight}
                        locale={this.props.locale}
                        direction={"D"}
                      />
                    </div>
                  </div>
                  <div className="trip-wrapper">
                    <div className="trip-label">{this.props.homeTripLabel}</div>
                    <div
                      className="flight"
                      style={
                        isMobile && departingTripOverlayOpen
                          ? { position: "relative", zIndex: "100" }
                          : isMobile && homeTripOverlayOpen
                            ? { position: "relative", zIndex: "9999999" }
                            : null
                      }
                    >
                      <FlightSearchComponent
                        {...this.props}
                        datetime={arrivalDate}
                        handleOverlay={this.handleHomeTripOverlay}
                        setDataToState={this.setDataToState}
                        chosenFlight={this.state.arrivalFlight}
                        locale={this.props.locale}
                        direction={"A"}
                      />
                    </div>
                  </div>
                  {this.state.departureFlight || this.state.arrivalFlight ? (
                    <div className="signup-link" onClick={() => this.handleSignup()}>
                      {this.props.signupLabel || "Tilmeld fly"}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        {this.state.showFlightSignupModal && (
          <ParkingFlightSignupModal
            {...{
              textKeys: { ...this.props.modalTextKeys, departingTripLabel: this.props.departingTripLabel, homeTripLabel: this.props.homeTripLabel },
              departureFlight: this.state.departureFlight,
              arrivalFlight: this.state.arrivalFlight,
              profile: this.props.profile,
              trackingEventLabel: "parking receipt",
              language: this.props.locale,
              email: this.props.email,
              phone: this.props.phone,
            }}
          />
        )}
      </>
    )
  }
}
